module.exports = __webpack_public_path__ + "img/g-kuyaowei-nan.105a6351.jpg";